import { Injectable, inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { PermissionService } from '@src/app/shared/services/permission.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuardService {

  constructor(private permissionService: PermissionService, public router: Router) { }

   async canActivate(route: any, state: any): Promise<boolean> {
    try
    {
      const requiredActions = route.data?.actions;
      const requiredFeature = route.data?.feature;
      var hasPermission = true;
      if(requiredActions != null)
      {
          hasPermission &&= await this.permissionService.hasActionPermissions(requiredActions);
      } 
     
      if(requiredFeature != null)
      {
          hasPermission &&= await this.permissionService.hasFeaturePermissions(requiredFeature);
      } 

      if (!hasPermission) {
        this.router.navigate(['/404'], { queryParams: { previousUrl: state?.url } });
      }

      return hasPermission;
    }
    catch(error)
    {
      this.router.navigate(['/404'], { queryParams: { previousUrl: state?.url } });
      return false;
    }
  }
}

export const PermissionGuard: CanActivateFn = (route, state) => {
  return inject(PermissionGuardService).canActivate(route, state);
};
